import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\CreatePackController::__invoke
* @see app/Http/Controllers/Pack/CreatePackController.php
* @route '/api/pack'
*/
const CreatePackController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePackController.url(options),
    method: 'post',
})

CreatePackController.definition = {
    methods: ["post"],
    url: '/api/pack',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Pack\CreatePackController::__invoke
* @see app/Http/Controllers/Pack/CreatePackController.php
* @route '/api/pack'
*/
CreatePackController.url = (options?: RouteQueryOptions) => {
    return CreatePackController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\CreatePackController::__invoke
* @see app/Http/Controllers/Pack/CreatePackController.php
* @route '/api/pack'
*/
CreatePackController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreatePackController.url(options),
    method: 'post',
})

export default CreatePackController